import { addDays, eachDayOfInterval, isSameDay } from 'date-fns';

import { HasDateRange } from '@ndvr/billing-api';

import { formatDate, parseLocalDate, tomorrowDate } from 'utils';

export const getDisabledDates = (rules: HasDateRange[] | undefined) => {
    if (!rules) {
        return [];
    }

    return rules
        .map(({ startDate, endDate }) => {
            return eachDayOfInterval({
                start: parseLocalDate(startDate),
                end: parseLocalDate(endDate || startDate),
            });
        })
        .flat();
};

export const isDateDisabled = (date: Date, disabledDates: Date[]) =>
    disabledDates.some((disabledDate) => isSameDay(date, disabledDate));

export const getFirstAvailableDate = (disabledDates: Date[]) => {
    let date = tomorrowDate();

    while (isDateDisabled(date, disabledDates)) {
        date = addDays(date, 1);
    }
    return formatDate(date, 'SERVER');
};
